import { Component } from '@angular/core';

@Component({
  selector: 'app-feature-preview-digital-signature',
  templateUrl: './feature-preview-digital-signature.component.html',
  styleUrls: ['./feature-preview-digital-signature.component.scss'],
})
export class FeaturePreviewDigitalSignatureComponent {}
